import { render, staticRenderFns } from "./JibaiseikiDialog.vue?vue&type=template&id=532a0cfd&"
import script from "./JibaiseikiDialog.vue?vue&type=script&lang=ts&"
export * from "./JibaiseikiDialog.vue?vue&type=script&lang=ts&"
import style0 from "./JibaiseikiDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports